import {
  type UserOrderResponseV2,
  type UserOrderResponseWithFlags,
} from '@redteclab/api/clients/bully'

import { type PublicGlobalConfig } from '../global-config'
import {
  urlResolverGetAccountOrders,
  urlResolverGetOrderQuestionMixedOrderSubOrderPickerPage,
  urlResolverGetOrderQuestionSubOrderDetailPage,
} from '../url-handling'

export const contactPageAccessorGetUrlForOrderCard = (
  config: PublicGlobalConfig,
  order: UserOrderResponseV2 | UserOrderResponseWithFlags,
): string => {
  if (
    !order.subOrders?.length ||
    !order.subOrders[0].subOrderId ||
    !order.orderMasterData?.orderNumber
  ) {
    return urlResolverGetAccountOrders(config)
  }

  return order.subOrders.length > 1
    ? urlResolverGetOrderQuestionMixedOrderSubOrderPickerPage(
        config,
        order.orderMasterData.orderNumber,
      )
    : urlResolverGetOrderQuestionSubOrderDetailPage(
        config,
        order.orderMasterData.orderNumber,
        order.subOrders[0]?.subOrderId,
      )
}
